/**
 * 缓存说明:充电桩缓存
 */
import vm from '@/cache/storeTools.js'
import archivesStore from '@/cache/archivesStore.js'
import deviceStore from '@/cache/deviceStore.js'
import siemensApi from '@/components/api/siemens/siemensApi.js'

var basestate = {
	//单位id与该单位本月订单金额和数量数据
	unitIdToMonthOrderInfo: {},
	deviceIdToInfo: {}, //桩id对应桩信息关联关系
	thisMonthPileOrder: {}, //本月的每个设备的订单总额
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getPileListByUnitId(state) {
			//指定单位下所有台账设备的列表
			return unitId => {
				var tree = deviceStore.getters.getReadDeviceTreeByUnitId(unitId)
				//递归获取树
				var list = treeToList(tree, 'next', item => {
					return item.hasOwnProperty("next")
				})
				//过滤出所有的台账
				return list.filter(item => {
					var isPile = item.archivesTypeCode == "ChargingPile"
					if (isPile) {
						vm.Vue.set(state.deviceIdToInfo, item.archivesId, item)
					}
					return isPile
				})
			}
		},
		getChargingStationListByUnitId() {
			//指定单位下充电站列表,不包括自己
			return unitId => {
				var unitList = treeToList(deviceStore.getters.getReadDeviceTreeByUnitId(unitId), 'next', item => {
					return item.hasOwnProperty("next")
				})
				return unitList.filter(item => {
					return item.devicetype == 3
				})
			}
		},
		getMonthOrderInfoByUnitId(state, getters) {
			//查询指定单位下的充电桩本月的充电订单数和时长
			return unitId => {
				if (isempty(unitId)) {
					return {
						count: 0,
						sumMoney: 0,
						sumTime: 0
					}
				}
				if (state.unitIdToMonthOrderInfo[unitId] == undefined) {
					//不存在就刷新一下
					store.commit("getMonthOrderInfoByUnitId", unitId)
					return {
						count: 0,
						sumMoney: 0,
						sumTime: 0,
						yearCount: 0,
						yearSumMoney: 0,
						yearSumTime: 0,
						lastCount: 0,
						lastSumMoney: 0,
						lastSumTime: 0,
					}
				}
				return state.unitIdToMonthOrderInfo[unitId]
			}
		},
		getPileThisMonthOrder(state) {
			//获取本月指定的充电桩的每天消费信息
			return pileIdsList => {
				var needGetIds = []
				var info = {}
				for (var i = 0, len = pileIdsList.length; i < len; i++) {
					var id = pileIdsList[i]
					var item = state.thisMonthPileOrder[id]
					if (item == undefined) {
						needGetIds.push(id)
					} else {
						info[id] = item
					}
				}
				if (needGetIds.length > 0) {
					store.commit('getPileThisMonthOrder', needGetIds)
				}
				return info
			}
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getMonthOrderInfoByUnitId(state, unitId) {
			//查询本月的指定单位的订单数
			var list = store.getters.getPileListByUnitId(unitId)
			var ids = list.map(item => {
				return item.no
			}).join(",")
			var now = new Date()
			//本月
			var sum = {
				count: 0,
				sumMoney: 0,
				sumTime: 0,
				yearCount: 0,
				yearSumMoney: 0,
				yearSumTime: 0,
				lastCount: 0,
				lastSumMoney: 0,
				lastSumTime: 0,
			}
			siemensApi.sumTimeAndMoneyBetweenTime(ids, new Date(now.getFullYear(), now.getMonth(), 1).getTime(), now.getTime(),
				respon => {
					eachObject(respon, item => {
						if (item == undefined) {
							return
						}
						sum.count += item.count
						sum.sumMoney += item.sumMoney
						sum.sumTime += item.sumTime
					})
					vm.Vue.set(state.unitIdToMonthOrderInfo, unitId, sum)
				})
			//去年同期
			siemensApi.sumTimeAndMoneyBetweenTime(ids, new Date(now.getFullYear() - 1, now.getMonth(), 1).getTime(), new Date(
					now.getFullYear() - 1, now.getMonth() + 1, 1).getTime() - 1,
				respon => {
					eachObject(respon, item => {
						if (item == undefined) {
							return
						}
						sum.yearCount += item.count
						sum.yearSumMoney += item.sumMoney
						sum.yearSumTime += item.sumTime
					})
					vm.Vue.set(state.unitIdToMonthOrderInfo, unitId, sum)
				})
			//上月
			siemensApi.sumTimeAndMoneyBetweenTime(ids, new Date(now.getFullYear(), now.getMonth() - 1, 1).getTime(), new Date(
					now.getFullYear(), now.getMonth(), 1).getTime() - 1,
				respon => {
					eachObject(respon, item => {
						if (item == undefined) {
							return
						}
						sum.lastCount += item.count
						sum.lastSumMoney += item.sumMoney
						sum.lastSumTime += item.sumTime
					})
					vm.Vue.set(state.unitIdToMonthOrderInfo, unitId, sum)
				})
		},
		getPileThisMonthOrder(state, ids) {
			var now = new Date()
			siemensApi.searchCountAndSumEveryDay(ids.join(','), new Date(now.getFullYear(), now.getMonth(),
				1).getTime(), now.getTime(), respon => {
				eachObject(respon, (item, key) => {
					vm.Vue.set(state.thisMonthPileOrder, key, item)
				})
			})
		}
	}
})

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
